import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProtestantCanonBooks } from '../../../../models/books.bible.model';
import {
  QuestionType,
  QuizQuestion,
} from '../../../../models/question.quiz.model';
import { MomentPipe } from '../../../../pipes/moment.pipe';
import { QuestionTypePipe } from '../../../../pipes/questionType.pipe';
import { BtnFabComponent } from '../../../components/buttons/btn-fab/btn-fab.component';
import {
  ChipColor,
  ChipComponent,
} from '../../../components/inputs/chip/chip.component';

@Component({
  selector: 'app-question-view',
  standalone: true,
  imports: [BtnFabComponent, ChipComponent, MomentPipe, QuestionTypePipe],
  templateUrl: './question-view.component.html',
  styleUrl: './question-view.component.css',
})
export class QuestionViewComponent {
  @Input() q!: QuizQuestion;
  @Input() isEditable: boolean = false;

  @Output() edit = new EventEmitter<QuizQuestion>();
  @Output() delete = new EventEmitter<QuizQuestion>();

  editQuestion() {
    this.edit.emit(this.q);
  }

  deleteQuestion() {
    this.delete.emit(this.q);
  }

  questionTypes = QuestionType;
  protestantBooks = ProtestantCanonBooks;
  chipColor = ChipColor;

  questionTypeValue(key: string): string {
    const questionTypesList = Object.entries(QuestionType).map(
      ([key, value]) => ({
        key: key, // e.g., 'multipleChoice'
        value: value, // e.g., 'Multiple Choice'
      }),
    );
    return questionTypesList.find((qt) => qt.key === key)?.value || key;
  }
}
